import { render, staticRenderFns } from "./ConferencePage.vue?vue&type=template&id=012cc292"
import script from "./ConferencePage.vue?vue&type=script&lang=js"
export * from "./ConferencePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports